function Body({ children }) {
  return <section className="body-section">{children}</section>;
}

export default Body;
